// Chart constants
export const defaultOrientationWarningTitle = 'Rotate screen horizontally';
export const defaultOrientationWarningMessage = 'For better chart readability, rotate your device horizontally.';
export const defaultChartWorkingDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

// Power type constants
export const powerTypes = {
  point: 'point',
} as const;

export type PowerType = (typeof powerTypes)[keyof typeof powerTypes];

// Data generation constants
export const allDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export const defaultWorkingDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
export const defaultPeakPower = 100;
export const defaultAveragePower = 50;
export const defaultWorkingHoursStart = '08:00';
export const defaultWorkingHoursEnd = '17:00';
export const timeIntervalMinutes = 15;
export const nighttimePowerRatio = 0.2;
